import useSWR, { preload, SWRConfiguration, SWRResponse } from 'swr';
import { peep_client } from '~/src/api/peep';
import { Uuid, UuidString } from '~src/utils/UUID';
import { GroupArray, GroupMemberArray } from '~/src/types/groups';

function groupMemberFetcher([_, group_id]: [string, UuidString]) {
  return peep_client.groups.getGroupMembers(group_id);
}
export function useGroupMembers(
  group_id: UuidString | undefined,
  swr_override: SWRConfiguration = {},
): SWRResponse<GroupMemberArray> {
  return useSWR(group_id ? ["get_group_members", group_id] : null, groupMemberFetcher, {
    ...swr_override,
  });
}

export function preloadGroupMembers(group_id: UuidString) {
  preload(['get_group_members', group_id], groupMemberFetcher);
}

function groupInfoFetcher([_, group_id]: [string, Uuid]) {
  return peep_client.groups.getGroupInfo();
}

export function useGroups(swr_override: SWRConfiguration = {}): SWRResponse<GroupArray> {
  return useSWR(['get_groups'], groupInfoFetcher, {
    ...swr_override,
  });
}
